import React from 'react'
import style from "css/address.module.css";

function AddressInputField({ label, child }) {
    return (
        <div className={style.addr_popup_inputField}>
            <div className={style.inputField_label}>
                {label}
            </div>
            {child}
        </div>
    )
}

export default AddressInputField
